import { Helmet } from 'react-helmet-async';
// sections
import { View500 } from 'src/sections/error';
import PropTypes from 'prop-types';
// ----------------------------------------------------------------------

export default function Page500({resetError}) {
  return (
    <>
      <Helmet>
        <title> 500 Internal Server Error</title>
      </Helmet>

      <View500 resetError={resetError} />
    </>
  );
}

Page500.propTypes = {
  resetError: PropTypes.func
};